import { RootState, useAppSelector } from "../store";

import { CoursesResponse } from "../api/api-model";
import ModalBase from "./ModalBase";
import React from "react";
import { useModal } from "../context/ModalContext";

interface NewTutroingData {
  uid: string;
}

interface NewTutroingModalProps {
  onConfirm: (data: NewTutroingData) => void;
}

export default function NewTutroingModal(props: NewTutroingModalProps) {
  const { onConfirm } = props;
  const { hideModal } = useModal();
  const [data, setData] = React.useState<NewTutroingData>({ uid: "" });
  const coursesResponse: CoursesResponse | null = useAppSelector(
    (state: RootState) => state.admin.coursesResponse
  );
  const user = useAppSelector((state: RootState) => state.admin.selectedUser);
  const inUse = React.useMemo(() => Object.keys(user?.tutorings || {}), [user]);
  const [tutorings, setTutorings] = React.useState<
    { uid: string; name: string }[]
  >([]);

  React.useEffect(() => {
    if (coursesResponse) {
      setTutorings(
        coursesResponse.tutorings
          .filter((t) => !inUse.includes(t.uid))
          .map((t) => ({
            uid: t.uid,
            name: t.name,
          }))
      );
    }
  }, [coursesResponse, inUse]);

  const handleConfirm = () => {
    onConfirm(data);
    hideModal();
  };

  const handleCancel = () => {
    hideModal();
  };

  return (
    <ModalBase
      header="Select a tutoring to add"
      body={
        <>
          <select
            value={data.uid}
            onChange={(e) => setData({ ...data, uid: e.target.value })}
          >
            <option value="">Select a tutoring</option>
            {tutorings.map((tutoring) => (
              <option key={tutoring.uid} value={tutoring.uid}>
                {tutoring.name}
              </option>
            ))}
          </select>
        </>
      }
      footer={
        <>
          <button className="loa-button-secondary" onClick={handleCancel}>
            Cancel
          </button>
          <button
            className="loa-button loa-button-primary"
            onClick={handleConfirm}
          >
            Confirm
          </button>
        </>
      }
    />
  );
}
